var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyxdLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 38,
    viewBox: "0 0 70 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3707 17.5048C50.5762 18.7077 51.7817 19.9107 51.7817 19.9107C53.4055 18.2903 53.4137 16.6782 51.8064 15.0743C50.6009 13.8713 49.7972 13.0693 49.8013 12.2633C47.7716 14.2887 47.7634 15.9009 49.3707 17.5048Z",
    fill: "#6B5325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7232 27.5786C49.7273 26.7725 50.5392 25.9623 51.757 24.7471C53.3808 23.1267 53.389 21.5146 51.7817 19.9106C51.7817 19.9106 50.5638 21.1259 49.346 22.3412C47.7222 23.9615 47.714 25.5737 49.7232 27.5786Z",
    fill: "#B58C3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9609 3.44165C40.1532 3.44575 39.3495 2.64379 38.144 1.44084C36.5367 -0.163095 34.9211 -0.154887 33.2974 1.46546C33.2974 1.46546 34.5029 2.66841 35.7083 3.87136C37.3157 5.4753 38.9312 5.46709 40.9609 3.44165Z",
    fill: "#FFC557"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8619 3.89598C32.0798 2.68072 33.2976 1.46545 33.2976 1.46545C31.6903 -0.138479 30.0747 -0.13027 28.451 1.49008C27.2331 2.70534 26.4212 3.51552 25.6135 3.51962C27.6226 5.52454 29.2382 5.51633 30.8619 3.89598Z",
    fill: "#B58C3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8015 12.2633C51.8312 10.2379 51.8394 8.62577 49.4284 6.21987L47.0174 3.81397C44.6064 1.40807 42.9909 1.41628 40.9612 3.44171C41.769 3.43761 42.992 4.623 44.5818 6.24449L46.9928 8.65039C48.5829 10.2714 49.8056 11.4573 49.8015 12.2633Z",
    fill: "#B58C3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6133 3.51965C23.6041 1.51474 21.9886 1.52295 19.5529 3.95347L17.1172 6.38399C14.6816 8.81452 14.6734 10.4267 16.6825 12.4316C16.6866 11.6255 17.887 10.3929 19.5282 8.78989L21.9639 6.35937C23.6046 4.75595 24.8055 3.52376 25.6133 3.51965Z",
    fill: "#FFC557"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7926 36.4905C42.8017 38.4955 44.4173 38.4872 46.8529 36.0567L49.2886 33.6262C51.7242 31.1957 51.7325 29.5835 49.7233 27.5786C49.7192 28.3847 48.5188 29.6173 46.8776 31.2203L44.4419 33.6508C42.8012 35.2542 41.6003 36.4864 40.7926 36.4905Z",
    fill: "#FFC557"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9413H10.9682V18.4258H4.47744V20.3474H9.1502V23.5315H4.47744V28.9377H0V14.9413Z",
    fill: "#3E3F41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8099 23.6122L11.2927 14.9413H16.0737L19.0606 19.7662L22.2399 14.9413H26.9998L21.2873 23.6122V28.9377H16.8099V23.6122Z",
    fill: "#3E3F41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5831 21.9103L27.1741 14.9413H32.3006L35.1343 18.6065L37.9891 14.9413H43.1156L37.7066 21.9103L43.1576 28.9377H38.0311L35.1313 25.214L32.2315 28.9377H27.105L32.5801 21.9103H32.5831Z",
    fill: "#3E3F41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8511 14.5695H61.2602C62.8757 14.5695 64.2853 14.8619 65.4889 15.4436C66.6926 16.0282 67.6265 16.8647 68.2878 17.9558C68.9491 19.0469 69.2797 20.3204 69.2797 21.7791C69.2797 24.1958 68.5633 26.0278 67.1276 27.2694C65.6949 28.514 63.7226 29.1333 61.2167 29.1333H55.8511V14.5667V14.5695ZM61.53 25.5097C62.6031 25.5097 63.4268 25.1769 64.004 24.5083C64.5811 23.8427 64.8712 22.931 64.8712 21.7791C64.8712 20.7516 64.5782 19.8978 63.9952 19.2148C63.4123 18.5317 62.6089 18.1931 61.5938 18.1931H60.1726V25.5069H61.53V25.5097Z",
    fill: "#3E3F41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyxdLogoColor);
export default __webpack_public_path__ + "static/media/fyxd-logo-color.83d31c54fea41b79483134aeef71c2b3.svg";
export { ForwardRef as ReactComponent };